module.exports = __webpack_public_path__ + "static/media/kemang.32b90e0e.png";